<template>
    <section class="search-calculator open">
        <div class="visual-container container">
            <div class="visual-section visual-section--intro">
                <h2 class="visually-hidden">내게 맞는 모바일 쿠폰(기프티콘, 상품권) 찾기</h2>
                <p class="visual-title">맞춤설정으로 편리하게 <br><strong>내게 맞는 상품</strong> 찾기</p>
            </div>
            <div class="collapse-layout">
                <InputCalculator></InputCalculator>
                <CategoryList></CategoryList>
                <!-- <BrandListWithSwiper></BrandListWithSwiper> -->
                <BrandListWithSlick></BrandListWithSlick>
                <SearchBtn></SearchBtn>
            </div>
        </div>
    </section>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
export default {
    components: {
        InputCalculator: () => import('@/components/main-item/search-calculator/InputCalculator.vue'),
        CategoryList: () => import('@/components/main-item/search-calculator/CategoryList.vue'),
        // BrandListWithSwiper: () => import('@/components/main-item/search-calculator/BrandListWithSwiper.vue'),
        BrandListWithSlick: () => import('@/components/main-item/search-calculator/BrandListWithSlick.vue'),
        SearchBtn: () => import('@/components/main-item/search-calculator/SearchBtn.vue'),
    },

    data(){
        return{
            // visibleCustomizedSearchSection: false,
            categoryList : [],
            brandList : []
        }
    },

    computed: {
        ...mapState({
            userData: state => state.userData,
            userNo: state => state.userNo,
            authentication: state => state.authentication,
            vuexIsVisibleMostTopBanner: state => state.alarmStore.vuexIsVisibleMostTopBanner,
        }),
    },

    created(){
        this.dispatchFindAllCategoryList();
    },

    methods: {
        ...mapMutations({
            setVuexCategoryAllList: 'exploreProductStore/setVuexCategoryAllList',
            setVuexBrandAllList: 'exploreProductStore/setVuexBrandAllList',
            setVuexCategorySearchValue: 'exploreProductStore/setVuexCategorySearchValue',
            setInitVuexCheckedCategory: 'exploreProductStore/setInitVuexCheckedCategory',
        }),

        async dispatchFindAllCategoryList() {
			try {
                const response = await this.$store.dispatch(
                    'categoryStore/actionsFindAllCategoryList', {}
                );
                this.categoryList = response.data;
                this.dispatchFindAllBrandList();
            } catch(err) {
                return;
            } 
		},

        async dispatchFindAllBrandList() {
			try {
                const response = await this.$store.dispatch(
                    'brandStore/actionsFindAllBrandList', {}
                );
                this.setVuexBrandAllList(response.data);
                this.setVuexCategoryAllList(this.categoryList);
                this.setInitVuexCheckedCategory(this.categoryList);
            } catch(err) {
                return;
            } 
		},
    },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/search-calculator.scss';
</style>